
import { Vue, Component } from 'vue-property-decorator'
import Option from '@/types/option'
import OptionEditDetailsTab from '@/views/option/tabs/edit/OptionEditDetailsTab.vue'
import OptionEditSubelementsTab from '@/views/option/tabs/edit/OptionEditSubelementsTab.vue'
import OptionEditEnabledIfTab from '@/views/option/tabs/edit/OptionEditEnabledIfTab.vue'
import OptionEditDisabledIfTab from '@/views/option/tabs/edit/OptionEditDisabledIfTab.vue'
import OptionEditSelectedIfTab from '@/views/option/tabs/edit/OptionEditSelectedIfTab.vue'
import OptionEditImagesTab from '@/views/option/tabs/edit/OptionEditImagesTab.vue'
import OptionEditDocumentsTab from '@/views/option/tabs/edit/OptionEditDocumentsTab.vue'
import ActivityLogTable from '@/components/ActivityLogTable.vue'
import OptionEditBudgetsTab from '@/views/option/tabs/edit/OptionEditBudgetsTab.vue'
import OptionAnalyticsTab from '@/views/option/tabs/OptionAnalyticsTab.vue'
import ls from '@/ls'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { OptionAnalyticsTab, OptionEditBudgetsTab, ActivityLogTable, OptionEditDocumentsTab, OptionEditImagesTab, OptionEditSelectedIfTab, OptionEditDisabledIfTab, OptionEditEnabledIfTab, OptionEditSubelementsTab, OptionEditDetailsTab }
})

export default class OptionEdit extends Vue {
  settings = {
    routeNames: { list: 'options', show: 'optionShow', edit: 'optionEdit' },
    routeParamKey: 'optionId',
    functionNames: { setCurrent: 'setCurrentOption', clearCurrent: 'clearCurrentOption', save: 'saveOption' },
    getterNames: { current: 'currentOption', loading: 'loadingOption' }
  }

  currentTab:string = ls.get('optionEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('optionEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, paramKey:string|undefined, id:number|undefined) : void {
    if (id && paramKey) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : Option {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }

  get navigationCollapsed () : boolean {
    return this.$store.getters.navigationCollapsed
  }

  get screenWidth () : number {
    return screen.width
  }
}
